export const AUTH_METHOD_BANK = 'BANK';
export const AUTH_METHOD_ID_CARD = 'ID_CARD';
export const AUTH_METHOD_IMPERSONATION = 'IMPERSONATION';
export const AUTH_METHOD_MOBILE_ID = 'MOBILE_ID';
export const AUTH_METHOD_SMART_ID = 'SMART_ID';
